var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgColleagueIconWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "24px",
    viewBox: "0 0 22 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E668F280-1899-4827-9A34-2CD671FE428F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.2-Company---Colleagues-with-no-positions",
    transform: "translate(-1085.000000, -1378.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person",
    transform: "translate(1061.000000, 1362.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0582358,11.6917106 C17.2750972,9.97359829 18.147679,7.05056298 17.2308992,4.4135712 C16.3141193,1.77657942 13.8099921,0.00669749157 10.9958095,0.00669749157 C8.18162695,0.00669749157 5.6774997,1.77657942 4.76071986,4.4135712 C3.84394001,7.05056298 4.7165218,9.97359829 6.93338329,11.6917106 C2.7531956,13.3401822 0.00716249756,17.3453528 -4.39305111e-15,21.8042553 L-4.39305111e-15,22.893617 C-4.39305111e-15,23.4952549 0.49210232,23.9829787 1.0991413,23.9829787 L20.8836846,23.9829787 C21.4907236,23.9829787 21.9828259,23.4952549 21.9828259,22.893617 L21.9828259,21.8042553 C21.9770997,17.3475069 19.2349692,13.3429497 15.0582358,11.6917106 L15.0582358,11.6917106 Z M6.59484778,6.55319149 C6.59484778,4.14664007 8.56325706,2.19574468 10.991413,2.19574468 C13.4195689,2.19574468 15.3879781,4.14664007 15.3879781,6.55319149 C15.3879781,8.95974291 13.4195689,10.9106383 10.991413,10.9106383 C8.56325706,10.9106383 6.59484778,8.95974291 6.59484778,6.55319149 L6.59484778,6.55319149 Z M2.19828259,21.8042553 C2.19828259,16.9911525 6.13510115,13.0893617 10.991413,13.0893617 C15.8477248,13.0893617 19.7845433,16.9911525 19.7845433,21.8042553 L2.19828259,21.8042553 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgColleagueIconWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/colleagueIconWhite.0b69a381f6770f60c33ba5a46f437388.svg";